import { ViewCpDetails } from "./ViewAllComponent/ViewCpDetails";
import { ViewAddressDetails } from "./ViewAllComponent/ViewAddressDetails";
import { ViewFirmDetails } from "./ViewAllComponent/ViewFirmDetails";
import { ViewBankDetails } from "./ViewAllComponent/ViewBankDetails";
import React, { useEffect, useState } from "react";
import { ViewPersonalDetails } from "./ViewAllComponent/ViewPersonalDetails";
import { ViewPersonalAddress } from "./ViewAllComponent/ViewPersonalAddress";
import { ViewMiscellaneousDetails } from "./ViewAllComponent/ViewMiscellaneousDetails";
import axios from "axios";
import { APIs } from "../../../utils/worker";
import { ViewDeliveryDetails } from "./ViewAllComponent/ViewDeliveryDetails";
import { useLocation } from "react-router";
import back_img from "../../../assests/images/rightVector.svg";
import { useNavigate } from "react-router";
import { Spin, message } from "antd";
import { camelCase, capitalize } from "../../../utils";
import { useParams } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import Navbar from "../../../components/Navbar";

function ViewDetails({ cpPirview, apiData }) {
  // let apiResponse1 = data;
  const [apiResponse, setApiResponse] = useState([]);
  const [motherHubName, setMotherHubName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const params = useParams();

  const history = useLocation();
  let userData = JSON.parse(localStorage.getItem("userinfo"));
  const { error, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  const apiTriger = () => {
    setLoading(true);
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    const headers = {
      Authorization: "Bearer " + userData.accessToken,
      userName: userData?.userName,
    };
    let url =
      userData?.type == "HUB"
        ? `${APIs.baseURL}/cp-onboarding/v1/getCpDetail/${history?.state?.id}`
        : `${APIs.baseURL}/cp-onboarding/v1/getCpDetail/${apiData?.premiseId}`;
    axios
      .get(url, {
        headers: headers,
      })
      .then((response) => {
        setApiResponse(response.data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        message.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (!fetching) {
      apiTriger();
    }
  }, [fetching]);

  const getUniqueListBy = (arr, key) => {
    return [...new Map(arr?.map((item) => [item[key], item])).values()];
  };

  let cpDetails = {
    cpName: apiResponse?.premiseDto?.premiseName,
    zone: apiResponse?.premiseDto?.zone,
    cpType: apiResponse?.premiseDto?.cpType,
    rateCardType: apiResponse?.premiseDto?.rateCardType,
    motherName: capitalize(apiResponse?.premiseDto?.parentPremiseName),
    billingCycle: apiResponse?.premiseDto?.billingCycle,
    mineHubConnected: apiResponse?.premiseDto?.mineHubConnected,
    mineHubName: apiResponse?.premiseDto?.mineHubName,
  };

  let cpAddressDetails = {
    address1: capitalize(apiResponse?.premiseDto?.addressLine1),
    address2: capitalize(apiResponse?.premiseDto?.addressLine2),
    pincode: apiResponse?.premiseDto?.pincode,
    city: camelCase(apiResponse?.premiseDto?.city),
    stateCode: apiResponse?.premiseDto?.stateCode,
    stateName: camelCase(apiResponse?.premiseDto?.state),
    latitude: apiResponse?.premiseDto?.latitude,
    longitude: apiResponse?.premiseDto?.longitude,
    premiseSubBranch: apiResponse?.premiseSubBranch,
  };

  let firmDetails = {
    proprietorName: camelCase(apiResponse?.miscellaneousDto?.proprietorName),
    msme: apiResponse?.miscellaneousDto?.msme,
    pan: apiResponse?.premiseDto?.pan,
    gstRegistred:
      apiResponse?.miscellaneousDto?.gstRegistred == true ? "Yes" : "No",
    firmType: apiResponse?.miscellaneousDto?.firmType,
    gst: apiResponse?.premiseDto?.gst,
    nameAsPerGST: camelCase(apiResponse?.miscellaneousDto?.firmName),
  };

  let bankDetails = {
    accountHolderName: camelCase(
      apiResponse?.miscellaneousDto?.accountHolderName
    ),
    bankName: camelCase(apiResponse?.miscellaneousDto?.bankName),
    accountNo: apiResponse?.miscellaneousDto?.accountNo,
    ifsc: apiResponse?.miscellaneousDto?.ifsc,
  };
  let personalDetails = {
    name: camelCase(apiResponse?.miscellaneousDto?.name),
    contactNo: apiResponse?.premiseDto?.phone,
    email: apiResponse?.premiseDto?.emailId,
    dob: apiResponse?.miscellaneousDto?.dob,
    altContactNo: apiResponse?.premiseDto?.mobilePhone,
    personalEmailId: apiResponse?.premiseDto?.personalEmailId,
    contactNumber: apiResponse?.premiseDto?.contactNumber,
  };

  let personalAddress = {
    rAddress1: capitalize(
      apiResponse?.miscellaneousDto?.residentialAddressLine1
    ),
    city1: camelCase(apiResponse?.miscellaneousDto?.permanentAddressCity),
    pAddress1: capitalize(apiResponse?.miscellaneousDto?.permanentAddressLine1),
    city2: camelCase(apiResponse?.miscellaneousDto?.residentialAddressCity),
    pAddress2: capitalize(apiResponse?.miscellaneousDto?.permanentAddressLine2),
    rAddress2: capitalize(
      apiResponse?.miscellaneousDto?.residentialAddressLine2
    ),
    education: apiResponse?.miscellaneousDto?.educationalQualification,
    state1: camelCase(apiResponse?.miscellaneousDto?.permanentAddressState),
    state2: camelCase(apiResponse?.miscellaneousDto?.residentialAddressState),
    marital: apiResponse?.miscellaneousDto?.maritalStatus,
    pincode1: apiResponse?.miscellaneousDto?.permanentAddressPincode,
    pincode2: apiResponse?.miscellaneousDto?.residentialAddressPincode,
    marriageDate: apiResponse?.miscellaneousDto?.marriageDate,
    cpInCharge: apiResponse?.premiseDto?.cpInCharge,
  };

  let miscellaneousDetails = {
    experience: apiResponse?.miscellaneousDto?.experienceInCourierIndustry,
    ownerShip: apiResponse?.miscellaneousDto?.officeOwnership,
    perviousCompany: apiResponse?.miscellaneousDto?.previousCourierCompanyName,
    officeInSQRT: apiResponse?.miscellaneousDto?.officeArea,
    monthlyTurnover: apiResponse?.miscellaneousDto?.monthlyTurnover,
    staff: apiResponse?.miscellaneousDto?.noOfStaff,
    checkVehicleAvailability:
      apiResponse?.miscellaneousDto?.checkVehicleAvailability,
    numberOfVehicles: apiResponse?.miscellaneousDto?.numberOfVehicles,
  };
  let arr1 = getUniqueListBy(apiResponse?.premiseDetails?.areas, "pincode");
  let arr2 = getUniqueListBy(apiResponse?.premiseDetails?.areas, "areaName");

  let deliveryDetails = {
    noofDeliveryPincode: arr1.length,
    areaName1: apiResponse?.premiseDetails?.areas,
    DeliveryPincode: arr1,
    cpPinCode: apiResponse?.premiseDetails?.pincode,
    areaName2: apiResponse?.premiseDetails,
    areaname: arr2,
  };

  return (
    <Spin spinning={loading}>
      {userData?.type == "HUB" && <Navbar />}

      <div className="p-2-tab">
        {userData?.type == "HUB" && (
          <p className="master-title">
            <img
              src={back_img}
              onClick={() => navigate("/cp-onbording", { state: "viewcp" })}
              className="pointer"
            />
            <span>{"CP Onboarding"}</span>
          </p>
        )}
        <div style={{ padding: "20px 180px", background: "white" }}>
          <ViewCpDetails
            cpDetails={cpDetails}
            id={history?.state?.id}
            apiResponse={apiResponse}
          />
          <ViewAddressDetails cpAddressDetails={cpAddressDetails} />
          <ViewFirmDetails
            firmDetails={firmDetails}
            apiResponse={apiResponse}
            id={history?.state?.id}
          />
          <ViewBankDetails bankDetails={bankDetails} />
          <ViewPersonalDetails
            personalDetails={personalDetails}
            apiResponse={apiResponse}
            id={history?.state?.id}
          />
          <ViewPersonalAddress personalAddress={personalAddress} />
          <ViewDeliveryDetails
            deliveryDetails={deliveryDetails}
            apiResponse={apiResponse}
            id={history?.state?.id}
          />
          <ViewMiscellaneousDetails
            miscellaneousDetails={miscellaneousDetails}
            apiResponse={apiResponse}
            id={history?.state?.id}
          />
        </div>
      </div>
    </Spin>
  );
}

export default ViewDetails;
